var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatMsgIconRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.21,
    height: 31.195,
    viewBox: "0 0 31.21 31.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12759",
    "data-name": "Group 12759",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3919",
    "data-name": "Path 3919",
    d: "M-87.694,198.926c0,.694,0,1.343,0,1.991a.614.614,0,0,1-.323.645c-.274.132-.472-.015-.669-.171-.957-.759-1.909-1.525-2.875-2.271a.96.96,0,0,0-.541-.185c-1.513-.014-3.027-.007-4.54-.009a2.708,2.708,0,0,1-2.875-2.857q0-2.792,0-5.583a2.706,2.706,0,0,1,2.854-2.843q4.944,0,9.888,0a2.7,2.7,0,0,1,2.847,2.85q0,2.791,0,5.583a2.709,2.709,0,0,1-2.849,2.85Zm-1.058,1.068c0-.555,0-1.014,0-1.473s.2-.649.661-.653c.482,0,.964,0,1.445,0a1.61,1.61,0,0,0,1.659-1.651q.005-2.925,0-5.849A1.609,1.609,0,0,0-86.66,188.7q-5.059,0-10.118,0a1.611,1.611,0,0,0-1.679,1.7q0,2.891,0,5.782a1.616,1.616,0,0,0,1.69,1.688c1.434,0,2.87.038,4.3-.015a2.414,2.414,0,0,1,1.85.653C-90.051,199.023-89.419,199.467-88.751,199.994Z",
    transform: "translate(115.135 -187.641)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3920",
    "data-name": "Path 3920",
    d: "M-327.882,454.852c-.539-.029-1.035-.017-1.519-.09a2.609,2.609,0,0,1-2.24-2.555q-.038-3.026,0-6.054a2.637,2.637,0,0,1,2.6-2.606q5.179-.037,10.359,0a2.641,2.641,0,0,1,2.613,2.632q.037,2.993,0,5.986a2.67,2.67,0,0,1-2.7,2.654c-1.569.013-3.139,0-4.708.012a.961.961,0,0,0-.541.186c-.959.739-1.9,1.5-2.85,2.249-.2.163-.405.33-.695.192s-.326-.395-.324-.678C-327.878,456.143-327.882,455.505-327.882,454.852Zm1.058,1.022c.144-.1.234-.164.318-.231.667-.528,1.339-1.052,2-1.591a1.212,1.212,0,0,1,.826-.294q2.488.019,4.975,0a1.6,1.6,0,0,0,1.587-1.585q.011-2.992,0-5.984A1.6,1.6,0,0,0-318.7,444.6q-5.16-.009-10.321,0a1.592,1.592,0,0,0-1.571,1.565q-.013,3.009,0,6.018A1.607,1.607,0,0,0-329,453.763c.5.006,1.009,0,1.513,0,.457,0,.656.2.66.654S-326.824,455.338-326.824,455.874Z",
    transform: "translate(331.66 -426.314)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M-277.046,231.505a8.044,8.044,0,0,0-2.469.693,9.841,9.841,0,0,0-5.889,7.636c-.085.482-.064.982-.109,1.472a.5.5,0,0,1-.55.509.509.509,0,0,1-.492-.563c0-.045,0-.09,0-.134a10.987,10.987,0,0,1,8.645-10.529c.324-.068.652-.12,1.047-.192l-.588-.6c-.1-.1-.21-.2-.308-.31a.526.526,0,0,1-.028-.776.526.526,0,0,1,.776.046c.252.239.491.492.739.734.329.32.658.64.993.954a.563.563,0,0,1,.025.88q-.915.915-1.837,1.823c-.282.277-.569.3-.8.076s-.22-.534.071-.823c.275-.273.564-.533.846-.8Z",
    transform: "translate(289.591 -225.813)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M-80.271,423.162c.287.281.561.542.827.811.294.3.323.589.091.826s-.543.191-.827-.084q-.856-.83-1.711-1.662a.56.56,0,0,1-.006-.858q.951-.927,1.911-1.844a.535.535,0,0,1,.8-.037.519.519,0,0,1-.061.773c-.294.3-.594.6-.939.948a9.273,9.273,0,0,0,3.461-1.161,9.847,9.847,0,0,0,5.01-7.4c.057-.386.062-.781.081-1.173.018-.375.219-.614.527-.611a.554.554,0,0,1,.52.622,10.807,10.807,0,0,1-2.638,7.019,10.728,10.728,0,0,1-6.723,3.724,1.782,1.782,0,0,0-.2.043A.97.97,0,0,0-80.271,423.162Z",
    transform: "translate(98.884 -396.617)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M-2.391,257.52a1.062,1.062,0,0,1,1.051,1.045,1.059,1.059,0,0,1-1.079,1.05,1.061,1.061,0,0,1-1.051-1.045A1.063,1.063,0,0,1-2.391,257.52Z",
    transform: "translate(25.549 -252.819)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3924",
    "data-name": "Path 3924",
    d: "M-50.4,259.623a1.06,1.06,0,0,1-1.065-1.03,1.059,1.059,0,0,1,1.063-1.065,1.06,1.06,0,0,1,1.065,1.03A1.06,1.06,0,0,1-50.4,259.623Z",
    transform: "translate(70.312 -252.826)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3925",
    "data-name": "Path 3925",
    d: "M53.584,259.619a1.048,1.048,0,1,1,1.078-1.052A1.061,1.061,0,0,1,53.584,259.619Z",
    transform: "translate(-26.684 -252.822)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3926",
    "data-name": "Path 3926",
    d: "M-178.42,515.616a1.061,1.061,0,0,1-1.05-1.045,1.063,1.063,0,0,1,1.079-1.05,1.062,1.062,0,0,1,1.05,1.046A1.059,1.059,0,0,1-178.42,515.616Z",
    transform: "translate(189.709 -491.595)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3927",
    "data-name": "Path 3927",
    d: "M-226.421,515.622a1.062,1.062,0,0,1-1.048-1.047,1.061,1.061,0,0,1,1.081-1.048,1.062,1.062,0,0,1,1.049,1.047A1.06,1.06,0,0,1-226.421,515.622Z",
    transform: "translate(234.479 -491.602)",
    fill: "#d10a11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3928",
    "data-name": "Path 3928",
    d: "M-282.4,515.619a1.061,1.061,0,0,1-1.07-1.058,1.061,1.061,0,0,1,1.059-1.037,1.061,1.061,0,0,1,1.07,1.059A1.058,1.058,0,0,1-282.4,515.619Z",
    transform: "translate(286.71 -491.599)",
    fill: "#d10a11"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMsgIconRed);
export default __webpack_public_path__ + "static/media/ChatMsgIconRed.f1bf3b483d105e95d57aebf3f2ad59f0.svg";
export { ForwardRef as ReactComponent };